// An AIpology — the clock: the song plays, the picture follows it, thirty frames a second (never smoother).
(function () {
  const H = window.HANA;
  const { clamp } = H;
  const $ = s => document.querySelector(s);
  const DEV = /dev/.test(location.hash);
  const FPS = 30;

  H.applyText();
  const audio = new Audio();
  audio.preload = 'auto';
  audio.src = 'music/song.m4a';

  const S = H.state = { mode: 'title', t: 0, clock: 0, playing: false, manual: null, lastFrame: -1 };

  // ---- audio
  const listen = $('#listen');
  let built = false, canPlay = false;
  const ready = () => { if (!built || !canPlay) return; listen.disabled = false; listen.textContent = H.text('listen'); };
  audio.addEventListener('canplay', () => { canPlay = true; ready(); }, { once: true });
  setTimeout(() => { canPlay = true; ready(); }, 4000);
  audio.addEventListener('ended', () => { S.playing = false; S.mode = 'end'; S.t = H.duration; $('#again').classList.add('on'); showBar(); });
  audio.addEventListener('play', () => { S.playing = true; setIcon(); });
  audio.addEventListener('pause', () => { S.playing = false; setIcon(); });

  let latency = 0;
  function measureLatency() {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      const ctx = new AC();
      latency = Math.min(0.5, (ctx.outputLatency || 0) + (ctx.baseLatency || 0));
      setTimeout(() => { latency = Math.min(0.5, (ctx.outputLatency || 0) + (ctx.baseLatency || 0)); ctx.close(); }, 1500);
    } catch (e) {}
  }

  function begin() {
    if (!latency) measureLatency();
    S.mode = 'play';
    $('#title').classList.add('gone');
    $('#again').classList.remove('on');
    audio.currentTime = 0; S.t = 0;
    audio.play().catch(() => {});
    showBar();
  }
  listen.addEventListener('click', () => { if (S.mode === 'title') begin(); });
  $('#again').addEventListener('click', () => { jump(0); begin(); });

  function toggle() {
    if (S.mode === 'title') return begin();
    if (S.mode === 'end') { jump(0); return begin(); }
    if (audio.paused) audio.play().catch(() => {}); else audio.pause();
  }
  function jump(t) {
    t = clamp(t, 0, H.duration - 0.05);
    S.t = t;
    try { audio.currentTime = t; } catch (e) {}
    if (S.mode === 'end' && t < H.duration - 0.1) { S.mode = 'play'; $('#again').classList.remove('on'); }
  }

  // ---- controls
  const bar = $('#bar');
  let barTimer = 0;
  function showBar() {
    if (S.mode === 'title') return;
    bar.classList.add('on');
    clearTimeout(barTimer);
    barTimer = setTimeout(() => { if (S.playing) bar.classList.remove('on'); }, 2600);
  }
  function setIcon() {
    $('#playIcon').setAttribute('d', S.playing ? 'M5 3v10M11 3v10' : 'M5 3l8 5-8 5z');
    $('#play').setAttribute('aria-label', H.text(S.playing ? 'aria.pause' : 'aria.play'));
  }
  $('#play').addEventListener('click', e => { e.stopPropagation(); toggle(); });
  $('#full').addEventListener('click', e => {
    e.stopPropagation();
    const d = document;
    if (d.fullscreenElement || d.webkitFullscreenElement) (d.exitFullscreen || d.webkitExitFullscreen).call(d);
    else { const el = d.documentElement; (el.requestFullscreen || el.webkitRequestFullscreen || (() => {})).call(el); }
  });
  const seekEl = $('#seek');
  let dragging = false;
  const seekTo = e => { const r = seekEl.getBoundingClientRect(); jump(clamp((e.clientX - r.left) / r.width, 0, 1) * H.duration); };
  seekEl.addEventListener('pointerdown', e => { e.stopPropagation(); dragging = true; seekEl.setPointerCapture(e.pointerId); seekTo(e); });
  seekEl.addEventListener('pointermove', e => { if (dragging) seekTo(e); });
  seekEl.addEventListener('pointerup', () => { dragging = false; });
  seekEl.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft') { jump(S.t - 5); e.preventDefault(); }
    if (e.key === 'ArrowRight') { jump(S.t + 5); e.preventDefault(); }
  });
  addEventListener('keydown', e => {
    if (e.target === seekEl) return;
    if (e.code === 'Space') { e.preventDefault(); toggle(); }
    else if (e.key === 'ArrowLeft' && S.mode !== 'title') jump(S.t - 5);
    else if (e.key === 'ArrowRight' && S.mode !== 'title') jump(S.t + 5);
    else if (e.key === 'f' || e.key === 'F') $('#full').click();
    showBar();
  });
  addEventListener('pointermove', showBar);
  addEventListener('pointerdown', showBar);

  // ---- the frame: drawn only when the 30 fps frame changes
  let last = performance.now(), raf = 0;
  function frame(now) {
    raf = requestAnimationFrame(frame);
    const dt = Math.min(0.1, (now - last) / 1000);
    last = now;
    S.clock += dt;
    step(dt);
  }
  function step(dt, force) {
    if (S.manual != null) S.t = S.manual;
    else if (S.mode === 'play' && S.playing) {
      const at = Math.max(0, audio.currentTime - latency);
      S.t += dt;
      if (Math.abs(at - S.t) > 0.12) S.t = at; else S.t += (at - S.t) * 0.08;
    }
    if (!built) return;
    const mode = S.mode === 'title' ? 'title' : 'play';
    const clockF = Math.floor(S.clock * FPS);
    const f = mode === 'title' ? -1 - clockF : Math.floor(S.t * FPS);
    if (f === S.lastFrame && !force) return;
    S.lastFrame = f;
    const tq = mode === 'title' ? 0 : f / FPS;
    const st = H.Director.frame(tq, mode, clockF / FPS);
    H.G.render(st);
    const frac = S.t / H.duration;
    seekEl.firstElementChild.style.width = (frac * 100).toFixed(3) + '%';
    seekEl.lastElementChild.style.left = (frac * 100).toFixed(3) + '%';
    seekEl.setAttribute('aria-valuenow', S.t.toFixed(0));
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { cancelAnimationFrame(raf); raf = 0; }
    else if (!raf) { last = performance.now(); raf = requestAnimationFrame(frame); }
  });

  // build the type, then the stage
  H.Atlas.build(H.Director.chars()).then(() => {
    H.G.init($('#gl'));
    built = true;
    ready();
    if (DEV) window.__hana = {
      S, G: H.G, H, audio,
      at(t) { S.mode = 'play'; S.manual = t; $('#title').classList.add('gone'); S.lastFrame = -9; return t; },
      title() { S.mode = 'title'; S.manual = null; $('#title').classList.remove('gone'); },
      stop() { cancelAnimationFrame(raf); raf = 0; },
      step(n = 1, dt = 1 / FPS) { for (let i = 0; i < n; i++) { S.clock += dt; step(dt, true); } },
      jump
    };
  });
  raf = requestAnimationFrame(frame);
})();
